import { render } from "./Preferences.vue?vue&type=template&id=c771bb0c&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"

import "./Preferences.vue?vue&type=style&index=0&id=c771bb0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c771bb0c"]])

export default __exports__